import { Controller } from "@hotwired/stimulus"

// Expense form: shows the amount fields for the document type and computes IVA, retention and total.
export default class extends Controller {
  static targets = ["type", "net", "iva", "retention", "total", "totalLabel", "netGroup", "ivaGroup", "retentionGroup", "totalGroup", "recoverableGroup"]
  static values = { retentionRate: Number }

  connect() {
    this.toggle()
  }

  toggle() {
    const type = this.typeTarget.value
    const invoice = type === "invoice"
    const fees = type === "fees"
    this.netGroupTarget.hidden = !(invoice || fees)
    this.ivaGroupTarget.hidden = !invoice
    this.recoverableGroupTarget.hidden = !invoice
    this.retentionGroupTarget.hidden = !fees
    this.totalTarget.readOnly = invoice || fees
    this.totalLabelTarget.textContent = fees ? "Líquido pagado" : "Total"
    this.netChanged()
  }

  netChanged() {
    const type = this.typeTarget.value
    const net = parseInt(this.netTarget.value, 10) || 0
    if (type === "invoice") this.ivaTarget.value = Math.round(net * 0.19)
    if (type === "fees") this.retentionTarget.value = Math.round(net * this.retentionRateValue / 100)
    this.recalculate()
  }

  recalculate() {
    const type = this.typeTarget.value
    const net = parseInt(this.netTarget.value, 10) || 0
    if (type === "invoice") this.totalTarget.value = net + (parseInt(this.ivaTarget.value, 10) || 0)
    if (type === "fees") this.totalTarget.value = net - (parseInt(this.retentionTarget.value, 10) || 0)
  }
}
